import React from "react";
import {BudgetFilter} from "../popoverFilters/budgetFilter/budgetFilter.jsx";
import {LocationFilterPopoverFactory} from "../popoverFilters/locationFilter/LocationFilterPopverFactory.jsx";
import {SpecificResultFilterPopoverFactory} from "../popoverFilters/accuracyResultsFilter/AccuracyResultsPopverFactory.jsx";
import {SearchTextFilter} from "../popoverFilters/searchTextFilter/SearchTextFilter.jsx";
import {DateTimeFilterPopoverFactory} from "../popoverFilters/dateTimeFilter/DateTimeFilterPopoverFactory.jsx";
import {isDateTimeFilterEnabled} from "../popoverFilters/dateTimeFilter/consts.jsx";

const filters = {
    budgetFilter: "BudgetFilter",
    locationFilter: "LocationFilter",
    accuracyResultsFilter: "AccuracyResultsFilter",
    searchFilter: "searchFilter",
    dateTimeFilter: "DateTimeFilter"
};

export const filterOptions = (panel, addressName) => {
    const options = [
        {
            label: <SearchTextFilter />,
            value: filters.searchFilter
        },
        {
            label: <BudgetFilter />,
            value: filters.budgetFilter
        },
        {
            label: <LocationFilterPopoverFactory panel={panel} addressName={addressName} />,
            value: filters.locationFilter
        }
    ];

    // Add date/time filter right after location filter if enabled for this panel
    if (isDateTimeFilterEnabled(panel)) {
        options.push({
            label: <DateTimeFilterPopoverFactory panel={panel} />,
            value: filters.dateTimeFilter
        });
    }

    options.push({
        label: <SpecificResultFilterPopoverFactory panel={panel} />,
        value: filters.accuracyResultsFilter
    });

    return options;
};
